import { onBeforeUnmount, watch } from 'vue'
import { trackGoal } from '@/helpers/metrika'

export const trackCalculation = (calculator, params = {}) => {
  trackGoal('calculation_success', { calculator, ...params })
  window.dispatchEvent(new CustomEvent('calculator:result', {
    detail: { calculator },
  }))
}


export const useComputedCalculationTracking = (calculator, source, delay = 800) => {
  let timer = null
  let lastTrackedValue = null

  const stop = watch(source, (value) => {
    if (timer) clearTimeout(timer)

    const numericValue = Number(value)
    if (!Number.isFinite(numericValue) || numericValue <= 0) {
      lastTrackedValue = null
      return
    }

    const localValue = String(value)
    if (localValue === lastTrackedValue) return

    timer = setTimeout(() => {
      lastTrackedValue = localValue
      trackCalculation(calculator)
    }, delay)
  }, { flush: 'post' })

  onBeforeUnmount(() => {
    stop()
    if (timer) clearTimeout(timer)
  })
}
